module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CD-58cde083803a8ea43b0a2f3a3628c633.png";